import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Monitoring.scss';
import {
  Card,
  CardBody,
  Col,
  Row,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from 'reactstrap';

import { MonitoringBaitData, SignalBaitData, SignalBaitTimeData } from 'api/visitReports/type';

interface MonitoringBaitProps {
  monitoring_bait_data: MonitoringBaitData[];
  slug: string | undefined;
}

const MonitoringBait: React.FC<MonitoringBaitProps> = ({ monitoring_bait_data, slug }) => {
  const { t } = useTranslation();
  const [openLeftIcon, setOpenLeftIcon] = useState('');
  const [innerOpenLeftIcon, setInnerOpenLeftIcon] = useState('');
  const toggleLeftIcon = (id: any) => {
    if (openLeftIcon !== id) {
      setOpenLeftIcon(id);
    }
    if (openLeftIcon === id) {
      setOpenLeftIcon('');
    }
  };

  const innerToggleLeftIcon = (id: any) => {
    if (innerOpenLeftIcon !== id) {
      setInnerOpenLeftIcon(id);
    }
    if (innerOpenLeftIcon === id) {
      setInnerOpenLeftIcon('');
    }
  };

  return (
    <Row className="m-2">
      <Col lg={12}>
        <Accordion
          className="lefticon-accordion custom-accordionwithicon accordion-border-box m-1"
          id="accordionlefticon"
          open={openLeftIcon}
          toggle={toggleLeftIcon}
        >
          <AccordionItem>
            <AccordionHeader className="py-3 accordion-header" targetId="monitoringBaitData">
              <i className={`ri-arrow-right-s-line fs-18 chevron ${openLeftIcon ? 'open' : ''}`} />
              {t('MonitoringBait.mainTitle')}
            </AccordionHeader>
            <AccordionBody accordionId="monitoringBaitData">
              {monitoring_bait_data.length === 0 ? (
                <h5 className="text-center text-danger">{t('MonitoringBait.main-noData')}</h5>
              ) : (
                monitoring_bait_data.map(trap => (
                  <Accordion
                    className="lefticon-accordion custom-accordionwithicon accordion-border-box m-1"
                    id="accordionlefticon"
                    open={innerOpenLeftIcon}
                    toggle={innerToggleLeftIcon}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId={`trapBaitData_${trap.id}`} className="py-3 accordion-header">
                        <div className="d-lg-flex align-items-center w-100">
                          {/* Column 1 1 */}
                          <div className="col-lg-1 text-center">
                            <div>
                              <i className="ri-scan-2-fill text-success fs-3" />
                            </div>
                          </div>

                          {/* Column 2 2 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">
                                {trap.trap_number ? (
                                  trap.trap_number
                                ) : (
                                  <h5 className="text-danger">{t('MonitoringBait.chieldAccordion.noTrapNumber')}</h5>
                                )}
                              </h5>
                              <p className="text-muted text-center mb-0">
                                {t('MonitoringBait.chieldAccordion.sequenceNumber')}
                              </p>
                            </div>
                          </div>

                          {/* Column 3 3 */}
                          <div className="col-lg-3">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.trap_type}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('MonitoringBait.chieldAccordion.trapType')}
                              </p>
                            </div>
                          </div>

                          {/* Column 4 4 */}
                          <div className="col-lg-2">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">{trap?.used_poison}</h5>
                              <p className="text-muted text-center mb-0">
                                {t('MonitoringBait.chieldAccordion.usedRodenticide')}
                              </p>
                            </div>
                          </div>

                          {/* Column 4 4 */}
                          <div className="col-lg-4">
                            <div className="ms-4">
                              <h5 className="fs-16 text-center mb-2">
                                <a
                                  href={`${process.env.REACT_APP_BASE_DJANGO_URL}/object/plan/trap/${slug}/${trap?.redirect_to_plan_url}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <i className="ri-map-pin-line text-success fs-1" />
                                </a>
                              </h5>
                              <p className="text-muted text-center mb-0">
                                {t('MonitoringBait.chieldAccordion.checkOnMap')}
                              </p>
                            </div>
                          </div>
                        </div>
                      </AccordionHeader>
                      <AccordionBody accordionId={`trapBaitData_${trap.id}`}>
                        {trap?.signals_data.length > 0 ? (
                          JSON.parse(trap?.signals_data).map((signal: SignalBaitData) => (
                            <Card className="card border mb-1">
                              <CardBody>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <h4 className="m-2 fs-16 d-flex align-items-center" style={{ whiteSpace: 'nowrap' }}>
                                    {t('Monitoring.accordion-father.accordion-child.accordion-inner-child.row-name')}{' '}
                                    {signal?.date}
                                  </h4>
                                  <div className="card m-3 w-100 card-to-line" />
                                  <div className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                    <UncontrolledDropdown className="m-2">
                                      <DropdownToggle tag="button" className="btn btn-light">
                                        {t(
                                          'Monitoring.accordion-father.accordion-child.accordion-inner-child.dropdown-title',
                                        )}{' '}
                                        {signal?.date} <i className="mdi mdi-chevron-down" />
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem>
                                          <table
                                            id={`trapSignals_${trap.id}`}
                                            className="table table-nowrap"
                                            style={{ width: '100%' }}
                                          >
                                            <thead className="">
                                              <tr>
                                                <th scope="col" style={{ width: '50%' }} className="text-center">
                                                  {t(
                                                    'MonitoringBait.chieldAccordion.innerChaildAccrordion.dropdownTable.time',
                                                  )}
                                                </th>
                                                <th scope="col" style={{ width: '50% ' }} className="text-center">
                                                  {t(
                                                    'MonitoringBait.chieldAccordion.innerChaildAccrordion.dropdownTable.rodenticide-in',
                                                  )}
                                                </th>
                                                <th scope="col" style={{ width: '50% ' }} className="text-center">
                                                  {t(
                                                    'MonitoringBait.chieldAccordion.innerChaildAccrordion.dropdownTable.added',
                                                  )}
                                                </th>
                                                <th scope="col" style={{ width: '50% ' }} className="text-center">
                                                  {t(
                                                    'MonitoringBait.chieldAccordion.innerChaildAccrordion.dropdownTable.eaten',
                                                  )}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                              {signal?.time.map((time: SignalBaitTimeData, index: number) => (
                                                <tr className="align-center text-center">
                                                  <td id={`DateIndex_${index}`}>
                                                    <i className="ri-timer-flash-line fs-18 text-success" />{' '}
                                                    {time.inner_time}
                                                  </td>
                                                  <td className="text-center" id={`TimeIndex_${index}`}>
                                                    {time.bait_filling}
                                                  </td>
                                                  <td
                                                    className={time.added_bait === 0 ? '' : 'text-success'}
                                                    id={`AddedBaitIndex_${index}`}
                                                  >
                                                    {time.added_bait === 0 ? time.added_bait : `+${time.added_bait}`}
                                                  </td>
                                                  <td
                                                    className={time.eaten_bait === 0 ? '' : 'text-danger'}
                                                    id={`EatenBaitIndex_${index}`}
                                                  >
                                                    {time.eaten_bait === 0 ? time.eaten_bait : `-${time.eaten_bait}`}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          ))
                        ) : (
                          <h5 className="text-danger text-center">{t('Monitoring.accordion-father.no-signal')}</h5>
                        )}
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                ))
              )}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </Col>
    </Row>
  );
};

export default MonitoringBait;
